import { render, staticRenderFns } from "./LglComplaints.vue?vue&type=template&id=eb90918e&"
import script from "./LglComplaints.vue?vue&type=script&lang=js&"
export * from "./LglComplaints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports